export { MissingConfigurationError } from './missing-configuration-error';
export { FeatureNotSupportedBySnykCodeError } from './unsupported-feature-snyk-code-error';
export {
  CodeClientError,
  CodeClientErrorWithDetail,
} from './code-client-error';
